import { Component, Input, OnInit } from "@angular/core";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-customer-boooking-header",
  templateUrl: "./customer-boooking-header.component.html",
  styleUrls: ["./customer-boooking-header.component.scss"],
})
export class CustomerBoookingHeaderComponent implements OnInit {
  isMobileView: boolean = false;
  @Input() data;
  @Input() isLinkOff: boolean = false;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.isMobileView = this.commonService.isMobile();
  }
}
